import React from 'react';
import Icon from '../../../components/AppIcon';

const GalleryStats = ({ photos }) => {
  const totalPhotos = photos?.length || 0;
  const uniqueSites = new Set(photos?.map(p => p?.siteId))?.size || 0;
  const uniqueWorkers = new Set(photos?.map(p => p?.uploadedBy))?.size || 0;
  const today = new Date()?.toDateString();
  const todayCount = photos?.filter(p => new Date(p?.createdAt)?.toDateString() === today)?.length || 0;

  const stats = [
    { label: 'Total Photos', value: totalPhotos, icon: 'Images', color: 'text-accent' },
    { label: 'Sites', value: uniqueSites, icon: 'Building2', color: 'text-blue-600' },
    { label: 'Workers', value: uniqueWorkers, icon: 'Users', color: 'text-emerald-600' },
    { label: 'Today', value: todayCount, icon: 'CalendarCheck', color: 'text-amber-600' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {stats?.map(stat => (
        <div key={stat?.label} className="bg-card border border-border rounded-xl p-4 shadow-elevation-1">
          <div className="flex items-center gap-2 mb-1">
            <Icon name={stat?.icon} size={15} className={stat?.color} />
            <span className="text-xs text-muted-foreground">{stat?.label}</span>
          </div>
          <p className={`text-2xl font-bold ${stat?.color}`}>{stat?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default GalleryStats;
